import styles from './Button.module.scss';
import cn from 'classnames';
import React from 'react';

type ButtonProps = {
    children?: React.ReactNode;
    className?: string;
    style?: 'filled' | 'lined';
    onClick?: () => void;
};
export const Button = (props: ButtonProps) => {
    const { children, className, style, onClick } = props;

    return (
        <button className={cn(styles.button, className, styles[style])} onClick={onClick}>
            {children}
        </button>
    );
};
